// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import mdEmphasis from "./mdEmphasis";
import pageTint from "./pageTint";
import articleLoader from "./articleLoader";
import stickyNav from "./stickyNav";

menuOpen();
mdEmphasis();
pageTint();
articleLoader();
stickyNav();